import api from "@/lib/axios";

const normalizeHotlists = (response) => {
  const items = Array.isArray(response)
    ? response
    : Array.isArray(response?.data)
      ? response.data
      : Array.isArray(response?.hotlists)
        ? response.hotlists
        : Array.isArray(response?.data?.hotlists)
          ? response.data.hotlists
          : [];

  return items
    .map((item) => ({
      value: String(
        item.id ?? item.hotlist_id ?? item.hotListID ?? item.value ?? "",
      ),
      label:
        item.name ??
        item.title ??
        item.label ??
        `Hotlist ${item.id ?? item.hotlist_id ?? ""}`,
    }))
    .filter((item) => item.value);
};

export const bullhornService = {
  getHotlist: async () => {
    try {
      const { data } = await api.get("/bullhorn/get-hotlist");
      return normalizeHotlists(data);
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch Bullhorn hotlist";
      throw new Error(message);
    }
  },
};
